



































































































































import { State, Action, Getter } from 'vuex-class';
import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';
import { ProfileState, User } from '../store/profile/types';
import axios from 'axios';
import store from '../store';
const namespace: string = 'profile';

@Component
export default class Welcome extends Vue {
  @Action('authenticateUser', { namespace }) public authenticateUser: any;
  @Action('registerUser', { namespace }) public registerUser: any;
  @Action('refreshUser', { namespace }) refreshUser: any;

    private signedIn: string = '';
    private newPage: string = 'Canvas';

    private showError: boolean = false;
    private errorMessage: string = 'Error when logging in. Please check e-mail and password.';
    private showRegisterError: boolean = false;
    private errorRegisterMessage: string = 'Error when signing up.';
    private formValid = true;
    private form2Valid = true;

    private email: string = '';
    private password: string = '';

    private registerEmail: string = '';
    private registerPassword: string = '';
    private registerCode: string = '';

    private firmName: string = '';
    private orgNr: string = '';
    private sector: string = '';
    private target: string = '';
    private employees: string = '';
    private selectedPositions: string[] = [];
    private selectedTurnover: string = '';

    private sectors: string[] = [
        'Agriculture, forestry & fishing',
        'Automotive',
        'Bank & finance',
        'Construction',
        'Consultancy services',
        'Energy',
        'Facility management',
        'Food',
        'Healthcare',
        'Hotel & restaurant',
        'Insurance',
        'Information & communication',
        'IT',
        'Law',
        'Manufacturing',
        'Mining',
        'Pharma',
        'Public sector',
        'Retail',
        'Services',
        'Startup',
        'Travelling',
        'University/academia',
        'Water supply',
    ]

    private targets: string[] = [
        'Consumers',
        'Companies',
    ];

    private employeeRanges: string[] = [
        '1-10',
        '11-50',
        '51-250',
        '250+',
    ];

    private positions: string[] = [
        'CEO',
        'Part of the management team',
        'Marketing department',
        'HR department',
        'IT department',
        'Procurement department',
    ];

    private turnoverRanges: string[] = [
        '0-1 million Euro',
        '1-4 million Euro',
        '5-10 million Euro',
        '11-25 million Euro',
        '26-50 million Euro',
        '51-100 million Eur',
        '101-250 million Euro',
        '251-500 million Eur',
        'more than 500 million Euro',
    ];

    // form input rules
    private emailRules = [
        (v: any) => !!v || 'E-mail is required',
        (v: any) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ];

    private passwordRules = [
        (v: any) => !!v || 'Password is required',
        (v: any) => (v && v.length >= 8) || 'Password must have 8+ characters',
    ];

    private codeRules = [
        (v: any) => /[a-zA-Z]*\d*/.test(v),
    ];

    private async doLogin() {
        this.showError = false;

        const user = {email: this.email, password: this.password};

        await this.authenticateUser(user);

        const state: any = store.state;
        const userFromState = state.profile.user;

        if (userFromState != undefined && userFromState.isAuthenticated) {
            this.signedIn = userFromState.email;
            this.$emit('setSignedIn', this.signedIn);
            this.$emit('getCanvasData');
        }
        else {
            this.showError = true;
        }
    }

    private async doRegister() {
        this.showRegisterError = false;

        const user = {
            email: this.registerEmail,
            password: this.registerPassword,
            orgCode: this.registerCode,
            companyName: this.firmName,
            orgNr: this.orgNr,
            industry: this.sector,
            targetGroup: this.target,
            nrOfEmployees: this.employees,
            positions: this.selectedPositions,
            turnover: this.selectedTurnover,
        }

        await this.registerUser(user);

        const state: any = store.state;
        const userFromState = state.profile.user;

        if (userFromState != undefined && userFromState.isAuthenticated) {
            this.signedIn = userFromState.email;
            this.$emit('setSignedIn', this.signedIn);
            await this.refreshUser();
            this.$emit('getCanvasData');
            this.$emit('updatePage', this.newPage);
        }
        else {
            this.errorRegisterMessage = state.profile.errorMessage;
            this.showRegisterError = true;
        }
    }

    private updatePage(newPage: string) {
        this.$emit('updatePage', newPage);
    }

}
